import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateUser } from "examsbook-react-sdk/actions/getUser";

/**
 * useUserSelectedExams hook.
 * @returns {{exams: *, selectedExams: Array, addExamToSelectedList: addExamToSelectedList, saveSelectedExams: saveSelectedExams}}
 */
export default function useUserSelectedExams() {
    const dispatch = useDispatch();
    const [ selectedExams, setSelectedExams ] = useState([]);
    const [ userSelectedExamList, setUserSelectedExamList ] = useState([]);
    const user = useSelector(state => state.user);
    const exams = useSelector(state => state.exam);
    /**
     * Effect to get list of selected exams
     */
    useEffect(() => {
        if (user.selectedExams) {
            setSelectedExams(user.selectedExams);
        }
    }, [ user ]);

    /**
     * Effect to users selected exams.
     */

    useEffect(() => {
        let selectedExamList = [];
        if (user && user.selectedExams && user.selectedExams.length > 0 && exams && exams.category) {
            exams.category.forEach(data => {
                if (user.selectedExams.indexOf(data._id) > -1) {
                    data.label = data.name;
                    selectedExamList.push(data);
                }
            });
        }
        setUserSelectedExamList(selectedExamList);
    }, [ user, exams ]);

    function addExamToSelectedList(id) {
        let allExamsIds = (exams ? exams.category : []).map((exam) => {
            return exam._id;
        });
        let selectedExamsList = selectedExams;
        //if not selected before then select it.
        if (selectedExamsList.indexOf(id) === -1) {
            selectedExamsList.push(id);
        } else {
            //if already selected before. remove it.
            let index = selectedExamsList.indexOf(id);
            selectedExamsList.splice(index, 1);
        }
        //fix to previous bug where it was adding exam twice.
        let correctList = selectedExamsList && selectedExamsList.length > 0 ? selectedExamsList.filter((exam) => {
            return allExamsIds.indexOf(exam) > -1;
        }) : [];
        setSelectedExams(correctList);
    }

    function saveSelectedExams() {
        let uniqueExams = [];
        if (selectedExams) {
            selectedExams.forEach((examId) => {
                if (uniqueExams.indexOf(examId) === -1) {
                    uniqueExams.push(examId);
                }
            });
        }
        if (user) {
            let data = { 'selectedExams': uniqueExams };
            if (!user.selectedExam) {
                data = { 'selectedExams': uniqueExams, 'selectedExam': uniqueExams[0] };
            } else {
                //check if new exam selected list contain old selected exam
                let userSelectedExam = selectedExams && selectedExams.length > 0 ? selectedExams.filter((exam) => {
                    return exam === user.selectedExam;
                }) : [];
                //update  exam from list if old exam not in new list
                if (userSelectedExam.length === 0) {
                    data = { 'selectedExams': uniqueExams, 'selectedExam': uniqueExams[0] };
                }
            }

            dispatch(updateUser(user._id, data));
        }
    }

    function changeSelectedExam(examId) {
        if (examId) {
            let data = { selectedExam: examId };
            if (user && user._id) {
                dispatch(updateUser(user._id, data));
            }
        }
    }

    let selectedExam = user ? user.selectedExam : {};
    return {
        selectedExam,
        changeSelectedExam,
        exams,
        selectedExams, //ids only
        userSelectedExamList, //list with ids and names.
        addExamToSelectedList,
        saveSelectedExams
    };
}
